import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class BoardNote extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'BoardNote'
  // Define default properties here
  static instanceDefaults () {
    return {
      compassId: null,
      posX: null,
      posY: null,
      noteWidth: null,
      noteHeight: null,
    }
  }

  static setupInstance (data, { models }) {
    if (data.board_notes_content) {
      data.board_notes_content = data.board_notes_content.map(content => new models.api.BoardNoteContent(content))
    }
    return data
  }
}
const servicePath = 'board-notes'
const servicePlugin = makeServicePlugin({
  Model: BoardNote,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
